import { combineReducers } from 'redux';
import compare from './compareReducer';
import userData from "./authReducer";
import translation from "./translationReducer";
export default combineReducers({
  compare,
  userData,
  translation
});